export enum DateTimeFormatEnum {
  FORMAT_1 = "format-1",
  FORMAT_2 = "format-2",
  FORMAT_3 = "format-3",
  FORMAT_4 = "format-4",
  FORMAT_5 = "format-5",
  FORMAT_6 = "format-6",
}
